export default "__VITE_ASSET__E$l4zFwe__"